export const ERROR_CODE = {
    USER_NOT_FOUND: 1000,
    USER_REFRESH_TOKEN_COOKIE_NOT_FOUND: 1001,
    USER_REFRESH_TOKEN_EXPIRED: 1002,
    USER_ALREADY_EXISTS: 1003,
    VERIFICATION_CODE_NOT_FOUND: 1004,
    REQUEST_NOT_ACTIVE: 1005,
    USER_HAS_BEEN_BLOCKED: 1006,
    EMAIL_USER_ALREADY_EXISTS: 1009,
    PHONE_USER_ALREADY_EXISTS: 1012,
    COMPANY_NOT_FOUND: 2000,
    COMPANY_NOT_ATTACHED_TO_CITY: 2001,
    DRIVER_IS_ACTIVE: 3000,
    DRIVER_NOT_FOUND: 3001,
    DRIVER_CITY_MISMATCH: 3002,
    REPORT_PERIOD_TOO_LONG: 5000,
    COMPANY_STATISTICS_DATA_NOT_FOUND: 5001,
    DRIVER_STATISTICS_DATA_NOT_FOUND: 5002,
    DRIVER_DATA_NOT_FOUND: 5003,
    ORDER_DATA_NOT_FOUND: 5004,
    USER_REQUEST_LIMIT_EXCEEDED: 4001,
    USER_REQUEST_PHONE_NUMBER_RESTRICTED: 4002,
}

export const ERROR_CODE_MESSAGES = new Map<number, string>([
    [ERROR_CODE.USER_NOT_FOUND, 'Почта или пароль введены неправильно'],
    [ERROR_CODE.USER_REFRESH_TOKEN_COOKIE_NOT_FOUND, 'Токен обновления не найден'],
    [ERROR_CODE.USER_REFRESH_TOKEN_EXPIRED, 'Сессия истекла, пожалуйста, войдите в систему снова'],
    [ERROR_CODE.USER_ALREADY_EXISTS, 'Пользователь с таким email уже существует'],
    [ERROR_CODE.EMAIL_USER_ALREADY_EXISTS, 'Пользователь с таким email уже существует'],
    [ERROR_CODE.PHONE_USER_ALREADY_EXISTS, 'Пользователь с таким номером уже существует'],
    [
        ERROR_CODE.VERIFICATION_CODE_NOT_FOUND,
        `Срок действия ссылки истёк. Напишите на почту ${__GLOBAL__.VITE_SUPPORT_EMAIL}, чтобы получить новую`,
    ],
    [ERROR_CODE.USER_HAS_BEEN_BLOCKED, 'Аккаунт недоступен. Обратитесь в поддержку'],
    [ERROR_CODE.DRIVER_IS_ACTIVE, 'Водитель уже активен'],
    [ERROR_CODE.REQUEST_NOT_ACTIVE, 'Заявка не активна'],
    [ERROR_CODE.REPORT_PERIOD_TOO_LONG, 'Слишком большой период. Выберите более короткий период'],
    [ERROR_CODE.COMPANY_STATISTICS_DATA_NOT_FOUND, 'Данные статистики компании не найдены'],
    [
        ERROR_CODE.DRIVER_STATISTICS_DATA_NOT_FOUND,
        'В выбранном периоде отсутствует статистика по водителям. Попробуйте изменить период или ослабить фильтры',
    ],
    [
        ERROR_CODE.DRIVER_DATA_NOT_FOUND,
        'Не удалось найти водителей по заданным параметрам. Проверьте фильтры и повторите попытку',
    ],
    [
        ERROR_CODE.ORDER_DATA_NOT_FOUND,
        'За указанный период не найдено заказов. Убедитесь, что выбраны корректные данные',
    ],
    [ERROR_CODE.COMPANY_NOT_ATTACHED_TO_CITY, 'Таксопарк не привязан к городу'],
    [ERROR_CODE.COMPANY_NOT_FOUND, 'Таксопарк не найден'],
    [ERROR_CODE.DRIVER_NOT_FOUND, 'Водитель не найден'],
    [ERROR_CODE.DRIVER_CITY_MISMATCH, 'Водитель находится в другом городе'],
    [ERROR_CODE.USER_REQUEST_LIMIT_EXCEEDED, 'Превышен лимит на создание заявок'],
    [
        ERROR_CODE.USER_REQUEST_PHONE_NUMBER_RESTRICTED,
        'Водителя добавляет другой пользователь. Вы можете попробовать добавить этого водителя позже',
    ],
])

export const getErrorMessage = (errorCode?: number) => {
    if (!errorCode) {
        return 'Неизвестная ошибка. Код ошибки отсутствует'
    }

    if (ERROR_CODE_MESSAGES.has(errorCode)) {
        return ERROR_CODE_MESSAGES.get(errorCode)
    }

    return 'Серверная ошибка. Код ошибки: ' + errorCode
}

// see: https://emailregex.com
export const EMAIL_REGEX_RFC5322 =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PAGE_SIZE = 10

export const LIMIT_OPTIONS: number[] = [10, 20, 30, 40, 50]

export type LimitType = (typeof LIMIT_OPTIONS)[number]

export const CODE_REGEX = new RegExp(/^\d{6}$/)

export const UUID_REGEX = new RegExp(
    /^[\da-f]{8}-[\da-f]{4}-7[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/
)

export const BREAKPOINTS = {
    MOBILE: 768,
    TABLET: 1024,
    DESKTOP: 1200,
    DESKTOP_XL: 1440,
}

export const TODAY = new Date()

export const PUBLIC_ERROR_CODE = {
    UIP_ID_NOT_FOUND: 1000,
    UIP_UPDATE_ERROR: 1001,
    UIP_ALREADY_CHANGED_STATUS: 1002,
}

export const PUBLIC_ERROR_CODE_MESSAGES = new Map<number, string>([
    [PUBLIC_ERROR_CODE.UIP_ID_NOT_FOUND, 'UIP ID не найден'],
    [PUBLIC_ERROR_CODE.UIP_UPDATE_ERROR, 'Ошибка при обновлении UIP'],
    [PUBLIC_ERROR_CODE.UIP_ALREADY_CHANGED_STATUS, 'UIP уже изменен'],
])

export const getPublicErrorMessage = (errorCode?: number) => {
    if (!errorCode) {
        return 'Неизвестная ошибка. Код ошибки отсутствует'
    }

    if (PUBLIC_ERROR_CODE_MESSAGES.has(errorCode)) {
        return PUBLIC_ERROR_CODE_MESSAGES.get(errorCode)
    }

    return 'Серверная ошибка. Код ошибки: ' + errorCode
}
